module.exports = __webpack_public_path__ + "static/media/icono-soporte.2b28dfb3.svg";